module.exports = __webpack_public_path__ + "1ca926255c5ff7132890246fbcac8cc5.jpg";